import { z } from 'zod';

export const entitlementsResolverSchema = z.object({
  /** Not required but if provided, allows us to query stripe subscriptions in a more real time fashion */
  stripeCustomerId: z.string().optional(),
  bypassCache: z.boolean().optional(),
  includeDebugData: z.boolean().optional(),
});
